import { useTranslation } from 'react-i18next'
import { formatBytes } from '@/components/features/media/mediaUpload'
import { formatClock } from '@/lib/player'
import { useCommunityTime } from '@/lib/hooks/useCommunityTime'
import type { MediaLibraryItem } from '@/lib/sdk-official/resources/media'

/** "Áudio · 45:10 · 46 MB · Maria Souza · 2 nov." — what tells two files apart in a list. */
export const useLibraryMeta = () => {
  const { t, i18n } = useTranslation('media')
  const { date } = useCommunityTime()
  return (item: MediaLibraryItem) => [
    t(`library.kind.${item.kind}`),
    item.durationSeconds ? formatClock(item.durationSeconds) : null,
    formatBytes(item.size, i18n.language),
    item.uploader?.name ?? null,
    date(item.createdAt),
  ].filter(Boolean).join(' · ')
}
